export default "__VITE_ASSET__Bh8Khb5s__"